import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbbea1b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OAcordeaoProjetos",
  "data-testid": "OAcordeaoProjetos"
}
const _hoisted_2 = { class: "OAcordeaoProjetos__SelecionarProjetos" }
const _hoisted_3 = { class: "OAcordeaoProjetos__Projetos" }

import { ref } from "vue"
  import Button from "primevue/button"
  import { OMensagemAcordeao, MMultiSelect } from "@/components/Gerais"
  import { OTabelaAcordeaoProjetos } from "@/components/Projetos"

  type ID = string
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OAcordeaoProjetos',
  setup(__props) {

  const projetosSelecionados = ref<ID[]>([])
  const projetosAdicionados = ref<ID[]>([])

  const adicionarProjetosSelecionados = () => {
    projetosAdicionados.value.push(...projetosSelecionados.value)
    projetosSelecionados.value = []
  }

  const indexAtivo = ref(1)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_unref(MMultiSelect), {
          modelValue: projetosSelecionados.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((projetosSelecionados).value = $event)),
          class: "OAcordeaoProjetos__MMultiselect",
          filter: true,
          nome: "projetos",
          "option-label": "nome",
          options: [],
          placeholder: "projetos"
        }, null, 8, ["modelValue"]), [
          [_vShow, indexAtivo.value === 1]
        ])
      ]),
      _withDirectives(_createVNode(_unref(Button), {
        onClick: adicionarProjetosSelecionados,
        class: "OAcordeaoProjetos__BotaoAdicionarSelecionados",
        label: "adicionar selecionados"
      }, null, 512), [
        [_vShow, indexAtivo.value === 1]
      ])
    ]),
    _withDirectives(_createVNode(_unref(OTabelaAcordeaoProjetos), { projetos: [] }, null, 512), [
      [_vShow, indexAtivo.value === 1]
    ]),
    _withDirectives(_createVNode(_unref(OMensagemAcordeao), {
      icon: "pi pi-map",
      responsabilidade: "projeto"
    }, null, 512), [
      [_vShow, indexAtivo.value === 0]
    ])
  ]))
}
}

})